<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M3.5 6C3.5 5.58579 3.16421 5.25 2.75 5.25C2.33579 5.25 2 5.58579 2 6V14C2 14.4142 2.33579 14.75 2.75 14.75C3.16421 14.75 3.5 14.4142 3.5 14V10.75H8V14C8 14.4142 8.33579 14.75 8.75 14.75C9.16421 14.75 9.5 14.4142 9.5 14V6C9.5 5.58579 9.16421 5.25 8.75 5.25C8.33579 5.25 8 5.58579 8 6V9.25H3.5V6Z"
            fill="#8E8E93"
        />
        <path
            d="M14.75 5.25C13.621 5.25 12.5707 5.7395 11.9771 6.55995C11.7343 6.89553 11.8095 7.36441 12.145 7.60722C12.4806 7.85004 12.9495 7.77483 13.1923 7.43925C13.4635 7.0645 14.0288 6.75 14.75 6.75C15.8813 6.75 16.5 7.45715 16.5 8C16.5 8.54285 15.8813 9.25 14.75 9.25C14.3358 9.25 14 9.58579 14 10C14 10.4142 14.3358 10.75 14.75 10.75C15.8813 10.75 16.5 11.4571 16.5 12C16.5 12.5429 15.8813 13.25 14.75 13.25C14.0287 13.25 13.4634 12.9355 13.1924 12.5608C12.9496 12.2252 12.4807 12.15 12.1451 12.3927C11.8095 12.6355 11.7342 13.1044 11.977 13.44C12.5706 14.2605 13.6209 14.75 14.75 14.75C16.3801 14.75 18 13.6663 18 12C18 11.1668 17.5949 10.4792 16.9861 10C17.5949 9.52079 18 8.83324 18 8C18 6.33365 16.3801 5.25 14.75 5.25Z"
            fill="#8E8E93"
        />
    </svg>
</template>
